var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('Banner'),_c('InvisibleShackles'),_c('FourEcosystems'),_c('Empower‌ment'),_c('OpennessWinWin'),_c('Decision'),_c('Piloting')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }